const IPV4_REGEX = /^(?:\d{1,3}\.){3}\d{1,3}$/;

const sanitizeHost = (value) => {
  const raw = String(value || '').trim().toLowerCase();
  if (!raw) return '';

  const noProtocol = raw.includes('://') ? (new URL(raw)).hostname : raw;
  return noProtocol.split(':')[0].split('/')[0];
};

const isLocalHost = (host) => {
  return host === 'localhost' || host === '0.0.0.0' || host === '127.0.0.1' || IPV4_REGEX.test(host);
};

export const getBrowserHost = () => sanitizeHost(window.location.hostname);

export const getTenantDomainFromHost = (hostValue = window.location.hostname) => {
  const host = sanitizeHost(hostValue);
  if (!host) return '';

  const parts = host.split('.').filter(Boolean);
  if (parts.length === 0) return '';

  if (parts[0] === 'www' && parts.length > 1) {
    return parts[1];
  }

  if (parts[0] === 'api' && parts.length > 1) {
    return parts[1];
  }

  return parts[0];
};

export const getApiBaseUrlFromHost = (hostValue = window.location.hostname, protocol = window.location.protocol) => {
  const host = sanitizeHost(hostValue);

  // Local development fallback (hosts file should map api.orderly.site -> 127.0.0.8)
  if (!host || isLocalHost(host)) {
    return 'http://api.orderly.site';
  }

  const parts = host.split('.').filter(Boolean);
  if (parts.length < 2) {
    return `${protocol}//api.${host}`;
  }

  const rootDomain = parts.slice(1).join('.');
  return `${protocol}//api.${rootDomain}`;
};
